import type { UniqueIdentifier } from "@dnd-kit/core";
import { type DragEndEvent } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";

import { CDndContext } from "./CDndContext";

interface Props {
  children: React.ReactNode;
  items: UniqueIdentifier[];
  onDragEnd: (event: DragEndEvent) => void;
}

export const SortableList: React.FC<Props> = ({ children, items, onDragEnd }) => {
  return (
    <CDndContext onDragEnd={onDragEnd}>
      <SortableContext items={items} strategy={verticalListSortingStrategy}>
        {children}
      </SortableContext>
    </CDndContext>
  );
};
